import { Markets } from 'context/AppContext'

const commonBackgroundImage = 'https://cdn2.enuygun.com/media/lib/uploads/image/homepage-bg-67774.webp'
const WINGIE_10_YEARS_BACKGROUND_IMAGE = 'https://cdn2.enuygun.com/media/lib/uploads/image/wingie-10-years-bg-75298.webp'

/**
 * Bu dosya, farklı pazarlar için arka plan görüntülerini yönetir.
 *
 * Kullanım:
 * 1. İstenen pazar için bir arka plan görüntüsü eklemek:
 *    backgroundImages nesnesine yeni bir giriş ekleyin.
 *    Örnek: us: 'https://ornek.com/us-arka-plan.webp'
 *
 * 2. Bir pazar için arka plan görüntüsünü almak:
 *    const backgroundImage = getBackgroundImage('us');
 *
 * 3. Varsayılan arka plan görüntüsünü almak:
 *    const defaultBackground = getBackgroundImage();
 *
 * Not: Eğer belirtilen pazar için özel bir görüntü tanımlanmamışsa,
 * varsayılan görüntü (commonBackgroundImage) kullanılacaktır.
 *
 * Kampanya: TR hariç tüm Wingie marketlerinde geçici olarak
 * WINGIE_10_YEARS_BACKGROUND_IMAGE kullanılır. Kampanya bitince
 * getBackgroundImage içindeki override kaldırılabilir.
 */

const backgroundImages: { [key: string]: string } = {
  default: commonBackgroundImage,
  ae: 'https://cdn2.enuygun.com/media/lib/uploads/image/ae-homepage-bg-72615.webp',
  sa: 'https://cdn2.enuygun.com/media/lib/uploads/image/sa-homepage-bg-72602.webp',
  pk: 'https://cdn2.enuygun.com/media/lib/uploads/image/arabia-bg-66462.webp',
  eg: 'https://cdn2.enuygun.com/media/lib/uploads/image/misir-homepage-bg-65659.webp',
  qa: 'https://cdn2.enuygun.com/media/lib/uploads/image/qa-homepage-bg-72616.webp',
  kw: 'https://cdn2.enuygun.com/media/lib/uploads/image/kw-homepage-bg-72617.webp',
  tr: 'https://cdn2.enuygun.com/media/lib/uploads/image/enuygun-hp-bg-75294.webp',
  az: 'https://cdn2.enuygun.com/media/lib/uploads/image/az-homepage-bg-72618.webp',
  bh: 'https://cdn2.enuygun.com/media/lib/uploads/image/bh-homepage-bg-72619.webp',
}

const getBackgroundImage = (market?: Markets): string => {
  if (market && market !== 'tr') {
    return WINGIE_10_YEARS_BACKGROUND_IMAGE
  }

  return (market && backgroundImages[market]) || backgroundImages['default']
}

export default getBackgroundImage
